import React, { useEffect, useState } from 'react';
import { AuthStatus, ReduxState } from 'interfaces';
import { connect, ConnectedProps } from 'react-redux';
import { ReactComponent as Download } from 'assets/icons/Download.svg';
import { ReactComponent as Notification } from 'assets/icons/Notification.svg';
import { Badge, Dropdown, MenuProps, Popover, QRCode } from 'antd';
import { IoIosArrowDown } from 'react-icons/io';
import { setAuth, setUserData } from 'redux/actions';
import { authToken, sendUserDataToLandingPage, userPhoneNumber, userProfile } from 'scripts';
import { Button } from '../button/button.index';
import { Notifications } from '30pay/profile/notifications/notifications.index';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'data/30pay.path';
import { ReactComponent as Home } from 'assets/icons/Home.svg';
import { Link } from 'react-router-dom';
import ENV from 'env.json';
import { IoCallOutline } from 'react-icons/io5';
import { getUnreadCount } from 'services';

const Header: React.FC<ConnectedProps<typeof connector> & { isSidebarCollapse: boolean }> = function (
    props: ConnectedProps<typeof connector> & { isSidebarCollapse: boolean },
) {
    const [unreadCount, setUnreadCount] = useState(0);
    const [countLoading, setCountLoading] = useState(false);

    useEffect(() => {
        getUnreadCount(setCountLoading, setUnreadCount);
    }, []);

    const navigate = useNavigate();
    const items: MenuProps['items'] = [
        {
            label: 'مشاهده پروفایل',
            key: '0',
            onClick: () => {
                navigate(PATH.profile);
            },
        },
        {
            label: 'تنظیمات',
            key: '1',
            onClick: () => {
                navigate(PATH.profile);
            },
        },
        {
            type: 'divider',
        },
        {
            label: 'خروج',
            key: '3',
            onClick: logout,
        },
    ];

    function logout() {
        authToken.remove();
        userProfile.remove();
        props.dispatch(setUserData(null));
        props.dispatch(setAuth(AuthStatus.inValid));
    }

    useEffect(() => {
        document.body.style.overflow = 'auto';
        const phoneNumber = userPhoneNumber.get();
        const token = authToken.get();
        const { expiresIn, fullName } = token ?? {};
        sendUserDataToLandingPage({
            loginDate: new Date().toISOString(),
            phoneNumber,
            expiresIn,
            fullName,
        });
    }, []);

    return (
        <div
            className={`flex items-center fixed h-[70px] z-50 bg-white gap-4 px-6 max-md:pr-3 border-darkPurple-20 border-b w-full ${props.isSidebarCollapse ? 'md:mr-[96px] md:w-[calc(100%-96px)]' : 'md:mr-[248px] md:w-[calc(100%-248px)]'} transition-all`}
        >
            <span className="flex-1 max-md:hidden" />
            <Dropdown menu={{ items }} trigger={['click']}>
                <div className="clickable rounded-2xl h-8 px-3 bg-white md:border border-primary-20 text-black-100 flex items-center gap-4 max-lg:gap-2 text-sm font-medium">
                    <h6>{props.user?.fullName ?? props.user?.phoneNumber}</h6>
                    <IoIosArrowDown />
                </div>
            </Dropdown>
            <span className="flex-1 md:hidden" />
            <div className="w-[1px] h-8 bg-primary-20 hidden md:block" />
            <div className="flex items-center gap-4 text-2xl text-[#000000]">
                <Link to={'tel:02191305087'}>
                    <IoCallOutline />
                </Link>
                <Popover
                    trigger={['click', 'hover']}
                    placement={'bottom'}
                    content={
                        <span>به زودی...</span>
                        // <div className={'flex flex-col'}>
                        //     <QRCode value={'https://cpy.viral-team.com'} bordered={false} />
                        //     <p className={'text-center mt-3 text-[10px] text-darkPurple-60 font-medium'}>
                        //         برای دانلود اسکن کنید.
                        //     </p>
                        //     <Button type="default" className={'!h-8 mt-4'} icon={<Download />}>
                        //         دانلود اپلیکیشن
                        //     </Button>
                        // </div>
                    }
                >
                    <Download className="clickable" />
                </Popover>
                <Popover
                    trigger={['click', 'hover']}
                    placement="bottom"
                    content={<Notifications isPreview onCountChange={setUnreadCount} />} // <-- hook it up
                >
                    <Badge
                        count={unreadCount}
                        overflowCount={99}
                        size="small"
                        showZero={false}
                        offset={[-2, 6]} // tweak to sit neatly on your SVG
                        className="h-6"
                    >
                        {/* Ensure the child can be positioned: */}
                        <span className="inline-flex relative">
                            <Notification className="clickable" />
                        </span>
                    </Badge>
                </Popover>
                <Link to={ENV.landing}>
                    <Home />
                </Link>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(Header);
